import React from 'react';
import styled from 'styled-components';

interface InputProps {
    type?: string;
    placeholder?: string;
    value: string;
    onChange: (value: string) => void;
    required?: boolean;
    onFocusChange?: (is_focus: boolean) => void;
}

interface MobileInputProps {
    autoCapitalize: string;
    autocapitalize: string;
    autocorrect: string;
    autocomplete: string;
    type?: string;
    placeholder?: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Container = styled.div`
    position: relative;
    @media only screen and (min-width: ${props =>
            props.theme.breakpoints.sm}px) {
        p {
            pointer-events: none;
            position: absolute;
            bottom: 12px;
            font-size: 14px;
            transition: all 0.4s;
            opacity: 0.7;
            &.active {
                color: #075ef2;
                opacity: 1;
                bottom: 32px;
            }
        }
    }
`;

const MobileInput = styled.input<MobileInputProps>`
    background-color: #fff;
    display: block;
    padding: 10px 0;
    font-size: 16px;
    border-radius: 0px;
    border-width: 0;
    border-bottom: 2px solid ${props => props.theme.colors.border};
    width: 100%;
    transition: all 0.3s;
    &:hover {
        border-color: ${props => props.theme.colors.brand[2]};
    }
    &:focus {
        border-color: ${props => props.theme.colors.brand[1]};
    }

    @media only screen and (min-width: ${props =>
            props.theme.breakpoints.sm}px) {
        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus,
        &:-webkit-autofill:active {
            -webkit-box-shadow: 0 0 0 30px white inset !important;
            & + p {
                color: #075ef2;
                opacity: 1;
                bottom: 32px;
            }
        }
    }

    @media only screen and (max-width: ${props =>
            props.theme.breakpoints.sm}px) {
        padding: 16px 0;
        font-size: 22px;
        & + p {
            bottom: 50px;
        }
    }
`;

export default ({
    type = 'text',
    placeholder,
    value,
    onChange,
    required,
    onFocusChange,
}: InputProps) => (
    <Container>
        <MobileInput
            type={type}
            autocorrect="off"
            autocapitalize="off"
            autoCapitalize="off"
            autocomplete="off"
            required={required}
            value={value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onChange(e.target.value)
            }
            onFocus={() => onFocusChange && onFocusChange(true)}
            onBlur={() => onFocusChange && onFocusChange(false)}
        />
        <p className={`${value.length > 0 ? 'active' : ''}`}>{placeholder}</p>
    </Container>
);



// WEBPACK FOOTER //
// ./src/components/Input.tsx